/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

import AppHeader from "../components/AppHeader";
import Footer from "../components/common/Footer";
import ActionsModal from "../components/common/ActionsModal";
import { unsetApiError } from "../slices/errorHandlingSlice";

import * as authUtils from "../helpers/auth/authUtils";

import landingPage from "../images/landing-page.png";

const StyledContainerGrid = styled(({ pageTitle, documentTitle, ...props }) => (
  <Grid {...props} />
))`
  background-image: ${(props) =>
    props.location.pathname === "/" ? `url(${landingPage})` : "none"};
  background-position: 0% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
`;

function PageLayout(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { documentTitle } = props;

  const sessionHasEnded = useSelector(
    (state) => state.goTrackUser.sessionHasEnded
  );
  const apiErrorHasOccurred = useSelector(
    (state) => state.errorHandling.apiErrorHasOccurred
  );

  useEffect(() => {
    document.title = documentTitle;
  }, [documentTitle]);

  return (
    <>
      <ActionsModal
        open={sessionHasEnded}
        affirmativeButtonText="Log In"
        handleAffirmative={() => {
          authUtils.acquireTokenRedirect();
        }}
        title="Session expired"
        message="Due to inactivity, your session has expired. Please log in again to continue."
      />
      <ActionsModal
        open={apiErrorHasOccurred}
        affirmativeButtonText="Refresh"
        handleAffirmative={() => window.location.reload()}
        negativeButtonText="Close"
        handleNegative={() => dispatch(unsetApiError())}
        title="Something went wrong"
        message={
          <>
            Sorry, we could not process this request. Please contact{" "}
            <a href="mailto:upscarriermgmttechnology@ups.com">
              upscarriermgmttechnology@ups.com
            </a>{" "}
            to report this error.
          </>
        }
        disableBackdropClick={false}
        disableEscapeKeyDown={false}
        handleClose={() => dispatch(unsetApiError())}
      />
      <StyledContainerGrid
        container
        direction="column"
        alignItems="stretch"
        wrap="nowrap"
        location={location}
        {...props}
      >
        <Grid item>
          <AppHeader
            pageTitle={props.pageTitle}
            contentPlaceholder={props.contentPlaceholder}
          />
        </Grid>
        {props.children}
        <Footer />
      </StyledContainerGrid>
    </>
  );
}

PageLayout.propTypes = {
  title: PropTypes.string,
  documentTitle: PropTypes.string.isRequired,
  contentPlaceholder: PropTypes.func,
};

export default PageLayout;
